import React, {useState} from 'react';
import {WithRouterProps} from 'react-router';

import {FILTER_OPTION, FilterOption} from './StudentSkillPath.types';
import {useStudentSkillPath} from './hooks/useStudentSkillPath';
import {BadgesAchieved} from './BadgesAchieved';
import {StudentSkillPathList} from './StudentSkillPathList';
import {StudentSkillPathDropdown} from './StudentSkillPathDropdown';

export function StudentSkillPath({params}: WithRouterProps) {
  const classroomId: string | undefined = params?.classroomId;
  const [selectedFilter, setSelectedFilter] = useState<FilterOption>(FILTER_OPTION.TO_DO);

  const {skillSubjectGroups, badgeCounts, isLoading} = useStudentSkillPath(
    classroomId,
    selectedFilter
  );

  return (
    <div className='student-skill-path flex w-full flex-col'>
      <div className='flex items-center justify-between px-x2 py-x3 m:px-x4'>
        <StudentSkillPathDropdown
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
        <BadgesAchieved badgeCounts={badgeCounts} />
      </div>
      <StudentSkillPathList skillSubjectGroups={skillSubjectGroups} isLoading={isLoading} />
    </div>
  );
}
